<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $tc('messages.questions', 2),
                        href: meta.links.index,
                    },
                    {
                        name: $t('messages.edit'),
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.update" method="post" @submit.prevent="submit">
            <TitleFieldsFormSection>
                <template v-slot:title>
                    {{ $t('messages.information') }}
                </template>
                <div class="md:grid md:grid-cols-12 md:gap-6">
                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.type')" for="type" />
                            <FormInput
                                required
                                id="type"
                                v-model="form.type"
                                name="type"
                                type="text"
                                max="191"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.type" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.title')" for="title" />
                            <FormInput
                                required
                                id="title"
                                v-model="form.title"
                                name="title"
                                type="text"
                                max="191"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.title" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.correct_answer')" for="correct_answer" />
                            <FormInput
                                required
                                id="correct_answer"
                                v-model="form.correct_answer"
                                name="correct_answer"
                                type="text"
                                max="191"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.correct_answer" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.description')" for="description" />
                            <FormInput
                                required
                                id="description"
                                v-model="form.description"
                                name="description"
                                type="text"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.description" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.options')" for="options" />
                            <FormInput
                                required
                                id="options"
                                v-model="form.options"
                                name="options"
                                type="text"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.options" class="mt-2" />
                        </div>
                    </div>
                </div>
            </TitleFieldsFormSection>

            <div class="flex justify-end mt-5">
                <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
            </div>
        </form>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import TitleFieldsFormSection from '@/components/TitleFieldsFormSection.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    components: {
        SubmitFormButton,
        PanelPage,
        TitleFieldsFormSection,
        FormInput,
        FormLabel,
        FormError,
    },
    layout: Layout,
    name: 'Edit',
    props: ['teacher', 'meta', 'options', 'question'],
    data() {
        return {
            form: this.$inertia.form({
                type: this.question.type,
                title: this.question.title,
                correct_answer: this.question.correct_answer,
                description: this.question.description,
                options: this.question.options,
            }),
        };
    },
    methods: {
        submit() {
            this.form.patch(this.meta.links.update);
        },
    },
};
</script>
